export const isEmptyObject = (value) => {
  // Handle null and undefined
  if (value == null) {
    return true;
  }

  // Check if it's an object and not an array
  if (typeof value !== "object" || Array.isArray(value)) {
    return false;
  }

  return Object.keys(value).length === 0;
};

export const getStatusColorAndVariant = (color) => {
  switch (color) {
    case "green":
      return { color: "success", chipColor: "success.main" };
    case "yellow":
      return { color: "warning", chipColor: "warning.main" };
    case "red":
      return { color: "error", chipColor: "error.main" };
    default:
      return { color: "default", chipColor: "text.secondary" };
  }
};
